import React, { useEffect, useState, useCallback } from 'react';
import ModalML from '@/components/ModalML';
import { useIntl } from 'umi';
import DataTableNativeML from '@/components/DataTableNativeML';
// import DataTable from '@/containers/data_table_ml/DataTable';
import { useDispatch, useSelector } from 'dva';
// import ButtonML from '@/components/button_ml/ButtonML';
import './ConsumptionRecord.less';
import dayjs from 'dayjs';
import ConsumptionRecordDetail from '../detail_components/CodeDetail.js';
import { Box } from '@material-ui/core';
import { fmtThousand } from '@/utils/comUtil';
import { discountTypeMap } from '@/constants.js';
import { optionToKey } from '@/utils/comUtil.js';
import { channelMap } from '@/constants.js';

const ConsumptionRecord = (props) => {
  //过于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const { params = {} } = props || {};
  const { id } = params || {};
  const dispatch = useDispatch();
  //获取详情的客户id
  const detailData = useSelector((state) => state.ml.getMemberDetail);
  const { customerId } = detailData || {};
  //获取订单列表
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['ml/getConsumptionRecord'];
  const { orderData } = useSelector((state) => state.orderDetail) || {};
  const datas = useSelector((state) => state.ml.getConsumptionRecord);
  // const [limit, setLimit] = useState(10);
  const [pageData, setPageData] = useState({
    pageSize: 10,
    pageNum: 1,
  });
  const { total, data = [], hasNext } = datas || {};
  // const [page, setPage] = useState(1);
  console.log('hasNext', hasNext);
  // 发起请求
  const setUseCallback = useCallback(() => {
    if (id) {
      dispatch({
        type: 'ml/getConsumptionRecord',
        payload: {
          values: {
            pageSize: pageData.pageSize,
            pageNum: pageData.pageNum,
            customerId: customerId, //会员编号
            memberId: id, //客户编号
            // userNo: 1, //客户编号
          },
        },
      });
    }
  }, [customerId, dispatch, id, pageData]);
  useEffect(() => {
    setUseCallback();
  }, [setUseCallback]);
  //关于modal弹框
  const [open, setOpen] = useState(false);
  const handleCancel = () => {
    setOpen(false);
  };

  const columns = [
    {
      title: formatMessage({ id: 'cm.member.detail.c02.lbl01' }),
      id: 'orderType',
      align: 'center',
      key: 'orderType',
      width: 100,
      render: ({ orderType: text }) => discountTypeMap[text],
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c02.lbl02' }),
      id: 'tradeTime',
      key: 'tradeTime',
      align: 'center',
      width: 160,
      render: ({ tradeTime: text }) => {
        return text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-';
      },
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c02.lbl03' }),
      id: 'orderNo',
      width: 256,
      align: 'center',
      key: 'orderNo',
      render: (record) => {
        return record.orderNo === '-' ? (
          <span>-</span>
        ) : (
          <span
            style={{ color: '#1c78c8', cursor: 'pointer' }}
            onClick={() => handleDetail(record.id)}
          >
            {record.orderNo}
          </span>
        );
      },
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c02.lbl04' }),
      id: 'originalOrderNo',
      width: 256,
      align: 'center',
      key: 'originalOrderNo',
      render: (record) => {
        return !record.originalOrderNo ? (
          <span>-</span>
        ) : (
          <span
            style={{ color: '#1c78c8', cursor: 'pointer' }}
            onClick={() => handleDetail(record.originalOrderId)}
          >
            {record.originalOrderNo}
          </span>
        );
      },
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c02.lbl05' }),
      id: 'channel',
      align: 'center',
      key: 'channel',
      width: 100,
      render: ({ channel: text }) => {
        let grade = '';
        grade = optionToKey(channelMap, text);
        return grade;
      },
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c02.lbl06' }),
      align: 'center',
      key: 'storeName',
      id: 'storeName',
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c02.lbl07' }),
      id: 'amountTotal',
      key: 'amountTotal',
      align: 'center',
      width: 100,
      render: ({ amountTotal }) => {
        return fmtThousand(amountTotal);
      },
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c02.lbl08' }),
      id: 'amountPaid',
      key: 'amountPaid',
      align: 'center',
      width: 100,
      // render: (text) => fmtThousand(text),
      render: ({ amountPaid }) => {
        return fmtThousand(amountPaid);
      },
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c02.lbl09' }),
      key: 'discount',
      id: 'discount',
      align: 'center',
      width: 100,
      // render: (text) => fmtThousand(text),
      render: ({
        //  discount,
        amountPaid,
        amountTotal,
      }) => {
        return fmtThousand((amountTotal - amountPaid).toFixed(2));
      },
    },
    {
      title: '订单状态',
      align: 'center',
      id: 'orderStatus',
      key: 'orderStatus',
      width: 100,
    },
  ];

  const handleDetail = (orderId) => {
    console.log('orderId', orderId);
    if (!orderId) {
      window.message.toast({
        type: 'error',
        message: '订单 ID 不存在',
        title: '错误',
      });
      return;
    }
    dispatch({
      type: 'orderDetail/getOrderDetail',
      payload: {
        values: {
          id: orderId,
        },
      },
    });
    setOpen(true);
  };

  return (
    <>
      <Box style={{ height: '100%' }}>
        <DataTableNativeML
          loading={loading}
          // pageButton={false}
          paging={true}
          // total={total}
          hasNext={hasNext}
          // title="会员列表"
          columns={columns}
          page={{
            ...pageData,
            total: total,
          }}
          initP={true}
          // buttonTitle={[{ text: '新增', onClick: edit }]}
          changePage={(pageObj) => {
            setPageData(pageObj);
          }}
          data={data}
          columnKey="id"
        ></DataTableNativeML>
        {/* <DataTable
        className="demo-test"
        columns={columns}
        rowSelection={false}
        pagination={{
          pageSize: limit,
          total: total,
          page: page,
        }}
        scroll={{ y: 'calc(100vh - 300px - 3.5rem)' }}
        dataSource={data}
        changePage={({ current }) => {
          setPage(current);
        }}
        changePageSize={(val) => {
          setLimit(val);
          setPage(1);
        }}
        loading={loading}
      /> */}

        <ModalML
          open={open}
          onClose={handleCancel}
          title={formatMessage({ id: 'cm.member.detail.d03.lbl01' })}
          isHasBcg={false}
        >
          <ConsumptionRecordDetail
            detail={{ ...orderData, orderItemList: orderData.orderItems }}
          />
        </ModalML>
      </Box>
    </>
  );
};
export default ConsumptionRecord;
